//index.js
import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
Vue.use(VueI18n);
import locale from "element-ui/lib/locale";
import elEn from "element-ui/lib/locale/lang/en";
import elCn from "element-ui/lib/locale/lang/zh-CN";
import elEs from "element-ui/lib/locale/lang/es";
import elPt from "element-ui/lib/locale/lang/pt";
import { EN, ZH, ES, PT, supportLangCodes } from "@/shared/const/langType";

function loadLocaleMessages() {
  //检测locales文件夹中有多少个语系
  const locales = require.context("../langs", true, /.json$/);
  const messages = {};
  locales.keys().forEach((file) => {
    const keyArr = file.split("/");
    keyArr.shift();
    messages[keyArr.join(".").replace(/\.json$/g, "")] = locales(file);
  });

  return {
    [ZH]: { ...messages[ZH], ...elCn },
    [EN]: { ...messages[EN], ...elEn },
    [ES]: { ...messages[ES], ...elEs },
    [PT]: { ...messages[PT], ...elPt },
  };
}

const storageLangCode = localStorage.getItem("localeLanguage");

const currentLangCode =
  storageLangCode && supportLangCodes.includes(storageLangCode)
    ? storageLangCode
    : _DEFAULT_LANGUAGE_;

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || currentLangCode,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || currentLangCode,
  messages: loadLocaleMessages(),
});
locale.i18n((key, value) => i18n.t(key, value));

// 暴露i18n
export default i18n;
